var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigmaLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3417 64.0001C24.1706 64.0001 26.8838 62.8763 28.8841 60.8759C30.8845 58.8755 32.0083 56.1624 32.0083 53.3334V42.6667H21.3417C18.5127 42.6667 15.7996 43.7906 13.7992 45.7909C11.7988 47.7913 10.675 50.5044 10.675 53.3334C10.675 56.1624 11.7988 58.8755 13.7992 60.8759C15.7996 62.8763 18.5127 64.0001 21.3417 64.0001Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.675 31.9999C10.675 29.1709 11.7988 26.4578 13.7992 24.4574C15.7996 22.4571 18.5127 21.3333 21.3417 21.3333H32.0083V42.6666H21.3417C18.5127 42.6666 15.7996 41.5428 13.7992 39.5424C11.7988 37.542 10.675 34.8289 10.675 31.9999Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.675 10.6667C10.675 7.83913 11.7977 5.12729 13.7963 3.12714C15.7948 1.12699 18.5058 0.00220901 21.3333 0L32 0V21.3333H21.3417C18.5127 21.3333 15.7996 20.2095 13.7992 18.2091C11.7988 16.2088 10.675 13.4956 10.675 10.6667Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0083 0H42.675C45.504 0 48.2171 1.12381 50.2175 3.12419C52.2179 5.12458 53.3417 7.83769 53.3417 10.6667C53.3417 13.4956 52.2179 16.2088 50.2175 18.2091C48.2171 20.2095 45.504 21.3333 42.675 21.3333H32.0083V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3417 31.9999C53.3417 34.8289 52.2179 37.542 50.2175 39.5424C48.2171 41.5428 45.504 42.6666 42.675 42.6666C39.846 42.6666 37.1329 41.5428 35.1325 39.5424C33.1321 37.542 32.0083 34.8289 32.0083 31.9999C32.0083 29.1709 33.1321 26.4578 35.1325 24.4574C37.1329 22.4571 39.846 21.3333 42.675 21.3333C45.504 21.3333 48.2171 22.4571 50.2175 24.4574C52.2179 26.4578 53.3417 29.1709 53.3417 31.9999Z",
    fill: "#1ABCFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogoIcon);
export default __webpack_public_path__ + "static/media/figma_logo_icon.65fb1c4014f22c909c649438e5e62a11.svg";
export { ForwardRef as ReactComponent };